import { buildGoalGroupingGoalListTree } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TreeItem } from 'shared/components/ui/virtualized-tree-list';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type Options = {
  hideArchived?: boolean;
  hideCompleted?: boolean;
  goalChildrenByParentId?: Map<ID, ID[]>;
  nestGoals?: boolean;
};

export const useGoalGroupingGoalListTree = (
  goals: Goal[],
  parentGoals: { id: ID; name: string }[],
  { hideArchived, hideCompleted, goalChildrenByParentId, nestGoals }: Options,
) => {
  const { t } = useTranslation();
  const allGoals = useSortedGoals();
  const links = useEntityLinks();

  return useMemo<Record<ID, TreeItem>>(
    () =>
      buildGoalGroupingGoalListTree(goals, {
        hideArchived,
        hideCompleted,
        ungroupedSectionName: t('projects.no-goal'),
        parentGoals,
        allGoals,
        links,
        goalChildrenByParentId,
        nestGoals,
      }),
    [
      goals,
      allGoals,
      parentGoals,
      links,
      t,
      hideArchived,
      hideCompleted,
      goalChildrenByParentId,
      nestGoals,
    ],
  );
};
